/* global window */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import CardTitlePart from '../../../parts/CardTitlePart';
import GhostButton from '../../../parts/GhostButton';
import TextCTA from '../../../layout/buttons/TextCTA';
import OverlayLoader from '../../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../../parts/SuccessConfirmationOverlay';
import PhoneNumEditor from './PhoneNumEditor';
import Settings from './Settings';
import AdminDetailsEditor from './AdminDetailsEditor';

// actions
import { requestPasswordReset } from '../../../actions/user';


// constants
const PW_REQUEST_MSG_TIMEOUT = 5000;

class _UserDetailsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      requestedPassState: 'none',
      editorOpen: false
    };
    this.handlePasswordReset = this.handlePasswordReset.bind(this);
    this.renderSofologistContent = this.renderSofologistContent.bind(this);
    this.toggleEditor = this.toggleEditor.bind(this);
  }

  setPwRequestState(state) {
    this.setState({ requestedPassState: state });
    if (['success', 'failure'].includes(state)) {
      this.setState({ requestedPassState: state });
      window.setTimeout(() => this.setPwRequestState('none'), PW_REQUEST_MSG_TIMEOUT);
    }
  }

  handlePasswordReset() {
    this.setPwRequestState('requested');
    this.props.requestPasswordReset(this.props.user.userId)
      .then(() => { this.setPwRequestState('success'); })
      .catch(() => { this.setPwRequestState('failure'); });
  }

  toggleEditor(e) {
    if(e) e.preventDefault();
    if (!this.props.isSofologist) return false;
    return this.setState(prev => ({ editorOpen: !prev.editorOpen }));
  }

  renderPwReset() {
    const { requestedPassState } = this.state;
    return [
      {
        requested: <OverlayLoader key="loader" active scale={0.5} background="rgba(255, 255, 255, 0.8)" />,
        success: <SuccessConfirmationOverlay key="successloader" content={'A password reset link has been sent to your email'} background="rgba(255, 255, 255, 1)" />,
        failure: <SuccessConfirmationOverlay key="failureloader" content={'Oops... Something went wrong resetting your password'} background="rgba(255, 255, 255, 1)" />
      }[requestedPassState] || null,
      <div className="reset__password" key="pw-preset">
        <p className="u-padding-bottom-small">need a password reset?</p>
        <GhostButton
          text="reset password"
          onBtnClick={this.handlePasswordReset}
          extraClass="u-w-100"
        />
      </div>
    ];
  }

  renderAddress(userData, addressType) {
    if (!userData) return null;
    var address = userData.addresses.find(a => a.type.toLowerCase() === addressType.toLowerCase());

    if (!address) address = userData.addresses.find(a => a.type.toLowerCase() === 'delivery');
    if (!address) return null; 


    return (
      <div className="delivery__details u-padding-small u-pale-grey-bg">
        <div className="u-padding-bottom-small"><strong>{addressType} address:</strong></div>
        {userData.firstName ? <div className="u-padding-bottom-tiny">{`${(userData.title || '')} ${(userData.firstName || '')} ${(userData.surname || '')}`.toUpperCase()}</div> : null}
        {address.line1 ? <div className="u-padding-bottom-tiny">{(address.line1 || '').toUpperCase()}</div> : null}
        {address.line2 ? <div className="u-padding-bottom-tiny">{(address.line2 || '').toUpperCase()}</div> : null}
        {address.line3 ? <div className="u-padding-bottom-tiny">{address.line3.toUpperCase()}</div> : null}
        {address.line4 ? <div className="u-padding-bottom-tiny">{address.line4.toUpperCase()}</div> : null}
        {address.postCode ? <div className="u-padding-bottom-tiny">{address.postCode.toUpperCase()}</div> : null}
      </div>
    );
  }

  renderContactDetails(user) {
    const userData = user.data;
    if (!userData) return null;
    const textTel = (userData.phoneNumbers || []).find(num => num.canText);
    const primaryPhone = (userData.phoneNumbers || []).find(num => num.primary);
    const primaryEmail = (userData.emailAddresses || []).find(e => e.primary);
    return (
      <div className="delivery__details u-padding-small u-margin-y-small u-pale-grey-bg">
        <div className="u-padding-bottom-small"><strong>Contact details:</strong></div>
        <div className="u-padding-bottom-small">
          <i className="sa sa-delivery-fast" /> We like to keep touch on delivery day
        </div>
        <div className="u-padding-bottom-tiny">{primaryEmail.address}</div>
        {!!textTel && (
          <div className="u-padding-top-tiny u-padding-bottom-small">
            {textTel.number}
            {textTel ? <PhoneNumEditor numberType="textTel" phoneNumber={textTel} /> : null}
          </div>
        )}
        {!!primaryPhone && (
          <div className="u-padding-top-tiny u-padding-bottom-small">
            {primaryPhone.number}
            {primaryPhone ? <PhoneNumEditor numberType="telephone1" phoneNumber={primaryPhone} /> : null}
          </div>
        )}
      </div>
    );
  }

  // We could do with moving this to umbraco once we have some designs
  renderIncorrectDetailsBlurb() {
    return (
      <div key="help-blurb" className="u-padding">
        <div className="incorrect__text u-padding-bottom-small">Don't worry at all. To change your address all you need to do is visit the store with some identification.</div>
        <div className="incorrect__text u-padding-bottom-small">You will require 2 forms of identification for your old address and 1 for your new address.</div>
        <div className="incorrect__text u-padding-bottom-small">Acceptable forms of identification are as follows:</div>
        <ul className="incorrect__text u-padding-small u-margin-bottom-small u-pale-grey-bg">
          <li>Driving license</li>
          <li>Bank Statement</li>
          <li>Credit card statement</li>
          <li>Utility bill</li>
          <li>Mortgage letter (tenancy agreement not acceptable)</li>
        </ul>
        <div className="incorrect__text u-padding-bottom-small">
          Once provided we will update your new address and book your delivery date.
        </div>
      </div>
    );
  }

  renderHelpSection() {
    return [
      <div key="help-action" className="u-clearfix c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          text={'incorrect? '}
          type={this.state.expanded ? 'shrink' : 'expand'}
          onBtnClick={() => this.setState({ expanded: !this.state.expanded })}
        />
      </div>,
      this.state.expanded && this.renderIncorrectDetailsBlurb()
    ];
  }

  renderSettingsSection() {
    return (
      <div className="delivery__details u-padding-small u-margin-top-small u-pale-grey-bg">
        <Settings />
      </div>
    );
  }

  renderSofologistContent() {
    if (!this.props.isSofologist) return null;
    const userData = this.props.user.data;
    return (
      <div>
        {!this.state.editorOpen && (
          <button
            onClick={this.toggleEditor}
            className="u-pull-right u-margin-top-tiny u-margin-right-tiny c-btn c-btn--link"
          >
            edit user
          </button>
        )}
        {this.state.editorOpen && <AdminDetailsEditor user={userData} onCancel={this.toggleEditor} />}
      </div>
    );
  }

  render() {
    const { title, user } = this.props;
    const userData = user.data;

    // default loader content
    let content = (
      <div className="u-position-relative u-padding">
        <OverlayLoader active />
      </div>
    );

    // basic content
    if (userData) {
      content = [
        this.renderSofologistContent(),
        <div className="u-padding-x-small u-padding-bottom-small">
          {this.renderContactDetails(userData)}
        </div>,
        <div className="u-padding-x-small u-padding-bottom-small">
          {/* {this.renderSettingsSection()} */}
          {this.renderPwReset()}
        </div>
      ];
    }

    // full post order/user update display
    if (user) {
      content = (
        <div className="u-padding-x-small">
          {this.renderSofologistContent()}
          {this.renderAddress(userData, 'Delivery')}
          {this.renderAddress(userData, 'Billing')}
          {this.renderContactDetails(user)}
          {this.renderHelpSection()}
          {/* {this.renderSettingsSection()} */}
          <div className="u-padding-small" style={{ position: 'relative' }}>
            {this.renderPwReset()}
          </div>
        </div>
      );
    }

    return (
      <div>
        <CardTitlePart title={title} />
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  isSofologist: state.sofologist.Authorized
});

const mapDispatchToProps = dispatch => bindActionCreators({
  requestPasswordReset
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(_UserDetailsCard);



// WEBPACK FOOTER //
// ./src/cards/templates/UserDetailsCard/index.js